import { UseDataQuery, UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { getGetBrandContextKey } from './context.keys';
import { getBrandContext } from './context.repository';
import { GetBrandContextOutput } from './context.types';

export const useGetBrandContext = ({
  teamId,
  ...options
}: Pick<UseDataQuery, 'teamId'> & UseDataQueryOptions = {}) =>
  useDataQuery<GetBrandContextOutput>(
    {
      queryKey: getGetBrandContextKey(),
      teamId,
      queryFn: async () => {
        const res = await getBrandContext();

        if (!res.ok) {
          throw res.originalError;
        }

        return res.data;
      },
    },
    options,
  );
